import request from "@/utils/request";
import dayjs from "dayjs";

// 获取告警分页列表
export function getList(params) {
  const {
    page: current,
    limit: size,
    date,
    sort,
    sortProp,
    ...otherWhere
  } = params;
  const whereKey = "dwr";
  const payload = {
    page: {
      current,
      size,
    },
    where: Object.entries(otherWhere).reduce(
      (where, [name, value]) => (
        (where[`lk_${whereKey}.${name}`] = value), where
      ),
      {}
    ),
  };
  if (date && Array.isArray(date) && date.length) {
    payload.where = {
      [`ge_${whereKey}.createTime`]: dayjs(date[0])
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
      [`le_${whereKey}.createTime`]: dayjs(date[1])
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
    };
  }
  if (sort) {
    let value = "";
    if (sort === "ascending") value += `asc_${whereKey}.`;
    if (sort === "descending") value += `desc_${whereKey}.`;
    if (value) {
      value += sortProp;
      payload.where[value] = 1;
    }
  } else {
    payload.where[`desc_${whereKey}.createTime`] = "1";
  }
  return request.post("/warning/getPage", payload);
}


// 确认处理告警
export function warningCheck(data) {
  return request.post("/warning/warningCheck", data);
}

// 批量处理告警
export function batchWarningCheck(data) {
  return request.post("/warning/batchWarningCheck", data);
}
